import PropTypes from 'prop-types';
import React from 'react';

import { TASK_QUEUE_TEAM_TABS } from '../../constants';
import { isTaskReadinessComplete } from '../../helpers';
import HuddleTaskRow from '../HuddleTaskRow';
import { groupTasksByTeam } from '../ReadinessDetail/teamGrouping';
import { TopicBand } from '../Visit';
import styles from './HuddleTasksSection.module.scss';

const TEAM_ORDER = TASK_QUEUE_TEAM_TABS.filter(({ key }) => key !== 'all').map(({ key }) => key);

const progress = (tasks) => {
  if (tasks.length === 0) return 'None';
  const done = tasks.filter((task) => isTaskReadinessComplete(task)).length;
  return done > 0 ? `${done}/${tasks.length} done` : `${tasks.length} open`;
};

const HuddleTasksSection = ({
  tasks = [],
  expanded,
  onExpandedChange,
  sectionRef,
  markingTaskId,
  assigningTaskId,
  onMarkComplete,
  onAssignToMe,
  onOpenTask,
}) => (
  <div ref={sectionRef} className={styles.section}>
    <TopicBand
      density="card"
      label="Outstanding tasks"
      meta={progress(tasks)}
      expanded={expanded}
      onToggle={() => onExpandedChange(!expanded)}
    />

    {expanded &&
      (tasks.length === 0 ? (
        <div className={styles.emptyRow}>Nothing outstanding for this visit.</div>
      ) : (
        groupTasksByTeam(tasks, TEAM_ORDER).map((group) => (
          <div
            key={group.team}
            role="group"
            aria-label={`${group.label}, ${progress(group.tasks)}`}
          >
            <TopicBand
              density="group"
              label={group.label}
              meta={progress(group.tasks)}
              className={styles.groupBand}
            />
            <div className={styles.rows}>
              {group.tasks.map((task) => (
                <HuddleTaskRow
                  key={task.id}
                  task={task}
                  isMarking={markingTaskId === task.id}
                  isAssigning={assigningTaskId?.has?.(task.id)}
                  onMarkComplete={onMarkComplete}
                  onAssignToMe={onAssignToMe}
                  onOpen={onOpenTask}
                />
              ))}
            </div>
          </div>
        ))
      ))}
  </div>
);

HuddleTasksSection.propTypes = {
  tasks: PropTypes.array,
  expanded: PropTypes.bool.isRequired,
  onExpandedChange: PropTypes.func.isRequired,
  sectionRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  markingTaskId: PropTypes.string,
  assigningTaskId: PropTypes.object,
  onMarkComplete: PropTypes.func.isRequired,
  onAssignToMe: PropTypes.func.isRequired,
  onOpenTask: PropTypes.func.isRequired,
};

export default HuddleTasksSection;
